module.exports = __webpack_public_path__ + "static/media/cz-flag.675b5be5.svg";